import { Colors, Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-left: ${Spacing.XxxLarge}px;
  padding-right: ${Spacing.XxxLarge}px;

  ${Media.Tablet`
    padding-bottom: 0px;
    margin-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
  `};

  ${Media.Mobile`
    height: auto;
    padding-bottom: 0px;
    margin-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
  `};
`
export default PageContainer
